import { render, staticRenderFns } from "./KYC.vue?vue&type=template&id=47c53f74&scoped=true&"
import script from "./KYC.vue?vue&type=script&lang=ts&"
export * from "./KYC.vue?vue&type=script&lang=ts&"
import style0 from "./KYC.vue?vue&type=style&index=0&id=47c53f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c53f74",
  null
  
)

export default component.exports